import Values from "./values";
// import { AgencyCompanyData } from "./enum/agentCompany";
export function keyToText(map, key) {
  if (!key && typeof key != "number") return; // 处理数字 0
  var m = map.find(e => e.key == key);
  var txt = m ? m.text : `未知(${key})`;
  return txt;
}
function numberText(n, radix = -1) {
  var dec = Number(n);
  var rp = dec.toString();

  var sign = Math.sign(dec);

  if (radix > -1) {
    rp = dec.toFixed(radix);
    dec = Number(rp);
  } else rp = (typeof n != "number" ? dec : n).toString();

  dec = Math.abs(dec);
  var int = Math.floor(dec);
  dec -= int;

  var i = rp.indexOf(".");
  rp = i == -1 ? "" : rp.substring(i);

  var buf = [];
  while (int > 999) {
    var nStr = ((int % 1000) + 1000).toString();
    buf.push(nStr.substring(1));
    int = Math.floor(int / 1000);
  }
  if (int == 0 && dec && sign < 0) buf.push("-0");
  else buf.push(int * sign);
  var str = buf.reverse().join(",") + rp;
  return str;
}

export function valueFormatter({ value }) {
  return numberText(value);
}

export default {
  dealTypeText: n => keyToText(Values.dealTypes, n),
  paymentText: n => keyToText(Values.paymentTypes, n),
  emptyText(v, empty) {
    if (v) return v;
    if (empty) return empty;
    return "N/A";
  },
  currencyText: (n, unit, radix = 2) => {
    var str = numberText(n, radix);
    if (!unit) return str;
    switch (unit) {
      case "RMB":
        return `￥${str}`;
      case "USD":
        return `US$${str}`;
      case "HKD":
        return `HK$${str}`;
      default:
        return `${str}(${unit})`;
    }
  },
  numberText,
  number(...args) {
    return numberText(...args);
  },
  dateText(dStr) {
    var d = new Date(Date.parse(dStr));
    if (isNaN(d)) return dStr;
    return d.toLocaleDateString();
  },
  datetimeText(dStr) {
    var d = new Date(Date.parse(dStr));
    if (isNaN(d)) return dStr;
    return d.toLocaleString();
  },
  statusText: n => keyToText(Values.statusTypes, n),
  receivingTypeText: n => keyToText(Values.hkReceivingTypes, n),
  timespanText: d => {
    var dt = new Date(d);
    if (isNaN(dt)) return d;
    var ts = (new Date() - dt) / 1000 / 60 / 60 / 24;
    var sign = Math.sign(ts);
    ts = Math.abs(ts);
    var msg;

    if (ts < 1) msg = `${Math.ceil(ts * 24)}小时`;
    else if (ts < 30) msg = `${Math.floor(ts)}天`;
    else if (ts < 365) msg = `${Math.ceil(ts / 30)}月`;
    else msg = `${Math.floor(ts / 365)}年`;
    return `${msg}${sign < 0 ? "内" : "前"}`;
  },
  hkStockOutType: n => keyToText(Values.hkStockOutTypes, n),
  imStockOutType: n => keyToText(Values.imStockOutTypes, n),
  // agencyCompanyText: (id, fullName) =>
  //   keyToText(
  //     AgencyCompanyData.map(e => {
  //       return { key: e.Id, text: fullName ? e.Name : e.ShortName };
  //     }),
  //     id
  //   )
};
